import styled, { keyframes } from 'styled-components';

interface ContainerProps {
  padding?: string;
  margin?: string;
  width?: string;
  textAlign?: string;
}

export const Container = styled.div<ContainerProps>`
  padding: ${(props) => props.padding || '0'};
  margin: ${(props) => props.margin || '0'};
  width: ${(props) => props.width || '100%'};
  text-align: ${(props) => props.textAlign || 'left'};
  max-width: 1200px;
`;

export const Title = styled.h1<{
  size?: string;
  color?: string;
  weight?: string;
}>`
  font-size: ${(props) => props.size || '1.5rem'};
  color: ${(props) => props.color || '#1a1a1a'};
  font-weight: ${(props) => props.weight || '600'};
  margin-bottom: 0.5rem;
  font-family: 'Inter', sans-serif;

  @media (max-width: 768px) {
    font-size: ${(props) => {
      const baseSize = props.size || '1.5rem';
      return `calc(${baseSize} * 0.9)`;
    }};
  }
`;

export const Card = styled.div<{ padding?: string }>`
  background-color: white;
  border-radius: 0.75rem;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: ${(props) => props.padding || '1.5rem'};
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    padding: ${(props) => props.padding || '1.25rem'};
    margin-bottom: 1rem;
  }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const LoadingSpinner = styled.div`
  border: 3px solid #f3f4f6;
  border-top: 3px solid #10b981;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: ${spin} 1s linear infinite;
  margin: 0 auto 1.5rem;

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
  }
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 6px;
  background-color: #f3f4f6;
  border-radius: 3px;
  overflow: hidden;
  margin: 1.5rem 0;
`;

export const ProgressBar = styled.div`
  height: 100%;
  background-color: #10b981;
  border-radius: 3px;
  width: 50%;
  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      width: 30%;
    }
    50% {
      width: 70%;
    }
    100% {
      width: 30%;
    }
  }
`;
